// adapted from source: https://estevanmaito.me/blog/accessible-navigation-using-react-router
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function AccessibleNavigationAnnouncer() {
  // the message that will be announced
  const [message, setMessage] = useState('')
  // get location from router
  const location = useLocation()

  // only run this when location change (note the dependency [location])
  useEffect(() => {
    // this logic is different from the source link above because the navigation labels and urls do not match
    setTimeout(() => { 
        // find the active nav link, get its label
        const activeNavLink = document.querySelector('.nav-link.active');
        if (activeNavLink && activeNavLink instanceof HTMLElement) {
            setMessage(`Navigated to ${(activeNavLink as HTMLElement).innerText} page.`)
        }
        else {
            setMessage('');
        }
        
    }, 100);
  }, [location])

  return (
    <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </span>
  )
}
